<template>
  <div id="test-intro">
    <comp-header
      :headerPosition="headerPos"
      :leftIcon="headerLeftIcon"
      :pageTitle="headerPageTitle"
      :leftClick="goPrevious">
    </comp-header>
    <div class="qr-wrapper">
      <div class="qr-container">
        <div class="qr-area">
          <vue-qr-reader
            v-if="show"
            v-on:code-scanned="codeScanned"
            :stop-on-scanned="false"
            :draw-on-found="true"
          />
          <button @click="show = !show">QR Video</button>
        </div>
        <p class="qr-txt" v-html="$t('match.qrScan.message')"></p>
      </div>

    </div>
    <comp-modal v-if="qrModal" @confirm="qrModal = !qrModal">
      <p slot="body">{{ qrModalBody }}</p>
    </comp-modal>
  </div>
</template>
<script>
import common from '@/utils/common';
import CompHeader from '@/components/CompHeader';
import VueQrReader from '@/components/VueQrReader';
import CompModal from '@/components/CompModal';

export default {
  name: 'test-intro',
  mixins: [
    common,
  ],
  data() {
    return {
      headerPos: 'on-top',
      headerLeftIcon: 'fa-chevron-left',
      headerPageTitle: this.$i18n.t('match.qrScan.header'),
      scanned: '',
      groupId: this.$route.params.groupId,
      show: true,
      qrModal: false,
      qrModalBody: '',
    };
  },
  components: {
    CompHeader,
    VueQrReader,
    CompModal,
  },
  methods: {
    codeScanned(code) {
      this.isLoading = false;

      if (this.groupId) {
        if (code.indexOf('/group/') !== -1) {
          this.qrModalBody = '올바르지 않은 QR 입니다.';
          this.qrModal = true;
        } else if (code.indexOf('@myInfoNum') !== -1) {
          const codeSlice = code.split('/');
          const tmpUserSeqId = codeSlice[codeSlice.length - 1];

          const params = {
            groupId: this.groupId,
            senderId: this.$store.getters.getUserSeqId,
            userToAdd: tmpUserSeqId,
          };
          this.$store
            .dispatch('qrInviteMember', params)
            .then(({ status, data }) => {
              if (status === 500) {
                this.qrModalBody = '한명이 문제를 다 풀지 않았습니다.';
                this.qrModal = true;
              } else if (status === 200) {
                this.$router.push({ path: '/match/list' });
              } else {
                this.qrModalBody = data.resultMsg || this.$i18n.error.title;
                this.qrModal = true;
              }
            });
        } else {
          this.$store
            .dispatch('qrInviteMemberWithURL', { code })
            .then(({ status, data }) => {
              if (status === 500) {
                this.qrModalBody = '한명이 문제를 다 풀지 않았습니다.';
                this.qrModal = true;
              } else if (status === 200) {
                this.$router.push({ path: '/match/list' });
              } else {
                this.qrModalBody = data.resultMsg || this.$i18n.error.title;
                this.qrModal = true;
              }
            });
        }
      } else if (code.indexOf('directAdd') !== -1) {
        this.$store
          .dispatch('qrInviteMemberWithURL', { code })
          .then(({ status, data }) => {
            if (status === 500) {
              this.qrModalBody = '한명이 문제를 다 풀지 않았습니다.';
              this.qrModal = true;
            } else if (status === 200) {
              this.$router.push({ path: '/match/list' });
            } else {
              this.qrModalBody = data.resultMsg || this.$i18n.error.title;
              this.qrModal = true;
            }
          });
      } else {
        const url = code.replace(
          '@myInfoNum',
          this.$store.getters.getUserSeqId,
        );
        if (url) {
          this.$store
            .dispatch('matchAdd', { url })
            .then(({ status, data }) => {
              if (status === 500) {
                this.qrModalBody = '한명이 문제를 다 풀지 않았습니다.';
                this.qrModal = true;
              } else if (status === 200) {
                this.$router.push({ path: '/match/list' });
              } else {
                this.qrModalBody = data.resultMsg || this.$i18n.error.title;
                this.qrModal = true;
              }
            });
        }
        this.scanned = url;
      }
    },
  },
};
</script>

<style lang="scss" src="../../scss/match-qr.scss" scoped>

</style>
<style scoped>
  .decoded-content {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    max-width: 100%;
    color: #fff;
    font-weight: bold;
    padding: 10px;
    background-color: rgba(0,0,0,.5);
  }
</style>



// WEBPACK FOOTER //
// src/views/match/match-qr-scan.vue